
interface CidadeBeneficiosProps {
  cidadeFormatted: string;
}

const CidadeBeneficios = ({ cidadeFormatted }: CidadeBeneficiosProps) => {
  return (
    <section className="py-16 px-6 md:px-12 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-seo-dark">
          Por que investir em SEO Local em {cidadeFormatted}?
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 text-seo-dark">Visibilidade local garantida</h3>
            <p>
              Quando potenciais clientes em {cidadeFormatted} buscam por serviços como o seu, 
              garantimos que sua empresa apareça nos primeiros resultados do Google.
            </p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 text-seo-dark">Mais chamadas e visitas</h3>
            <p>
              Com SEO Local otimizado para {cidadeFormatted}, sua empresa receberá mais ligações,
              direções no mapa e visitas ao seu estabelecimento.
            </p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 text-seo-dark">Concorrência local</h3>
            <p>
              Destaque-se da concorrência em {cidadeFormatted} e seja a primeira opção
              para consumidores da região que buscam seus produtos ou serviços.
            </p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 text-seo-dark">Resultados mensuráveis</h3>
            <p>
              Acompanhe métricas reais de desempenho e veja como sua presença digital
              em {cidadeFormatted} cresce mês após mês.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CidadeBeneficios;
